import { render, staticRenderFns } from "./messageChat.vue?vue&type=template&id=58de3932&scoped=true"
import script from "./messageChat.vue?vue&type=script&lang=js"
export * from "./messageChat.vue?vue&type=script&lang=js"
import style0 from "./messageChat.vue?vue&type=style&index=0&id=58de3932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de3932",
  null
  
)

export default component.exports